import { css } from '@linaria/core';
import theme from '../../../theme';

export const vertical = css``;

export const rule = css`
  background: ${theme.colors.peoople['gris-claro']};
  height: 1px;
  &.${vertical} {
    height: 100%;
    width: 1px;
  }
`;
